import React, { useState } from 'react';
import { Typography } from 'antd';

const { Paragraph } = Typography;

const EllipsisText = ({ value, rows = 2, style, expandable = 'collapsible', className = '' }) => {
  const [expanded, setExpanded] = useState(false);
  return (
    <Paragraph
      ellipsis={{
        rows,
        expandable,
        expanded,
        symbol: () => <span>{expanded ? 'Read Less' : 'Read More'}</span>,
        onExpand: (_, info) => setExpanded(info.expanded),
      }}
      style={{ ...style }}
      className={className}
    >
      {value}
    </Paragraph>
  );
};

export default EllipsisText;
